export default __webpack_public_path__ + "static/CustomersHero-ae940d1cafa7bdbfa2e4a38b3559e441.png";